import { NgModule, Component } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AdminLayoutComponent } from "./admin-layout.component";
import { UserManagementComponent } from "./user-management/user-management.component";

const routes: Routes = [
  {
    path: ":module",
    component: AdminLayoutComponent,
  },
  {
    path: ":module/user-management",
    component: UserManagementComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)]
})
export class AdminLayoutRoutingModule {}
